/**
 * DataBest — Date formatting helpers.
 *
 * All user-facing dates must render as MM/DD/YYYY (English/US format) per
 * product requirement. This is the single source of truth for that logic.
 *
 * The <input type="date"> element cannot be forced to a specific display
 * format — it follows the OS locale. That is a browser limitation. Value
 * exchange internally always uses ISO YYYY-MM-DD, which is unambiguous.
 */

const pad = (n) => String(n).padStart(2, "0");

/** Convert any ISO string (YYYY-MM-DD or full timestamp) to MM/DD/YYYY. Returns "—" for empty. */
export const formatDateUS = (iso) => {
    if (!iso) return "—";
    // Date-only string: parse manually to avoid TZ shift
    const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(iso);
    const d = dateOnly ? new Date(iso + "T00:00:00") : new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
};

/** MM/DD/YYYY plus 12-hour clock. Uses browser locale for the time zone. */
export const formatDateTimeUS = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    const time = d.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });
    return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()} ${time}`;
};

/** ISO YYYY-MM-DD for today's local calendar day. Useful for date inputs. */
export const todayISO = () => {
    const d = new Date();
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
